import { Controller } from "@hotwired/stimulus";

const csrfToken = document.querySelector("meta[name=\"csrf-token\"]")?.content || "";

export default class PurchaseAdUserController extends Controller {
  // connect() {
  // }

  userSelectDone(e) {
    e.preventDefault();
    let data = e.target.dataset;
    let index = data.index;
    let backskin = data.backskin;
    if (Number.parseInt(backskin) === $("#available-user-" + index + " input[type='checkbox'][name^='purchase_backskin[" + index + "]']:checked").length) {
      $(e.target).prop("disabled", true).html("<span class=\"spinner-border spinner-border-sm\" aria-hidden=\"true\"></span>\n" +
        "  <span>Loading...</span>");
      $("#confirm-user-" + 0).prop("checked", true);
      this.element.requestSubmit();
      addEventListener("turbo:submit-end", ((event) => {
        const otherController = this.application.getControllerForElementAndIdentifier($(`#edit_purchase_backskin_${index}`)[0], "purchase-ad");
        otherController.filterForm[index].confirm_user = true;
        $(e.target).prop("disabled", false).html("Continue");
        let modal = bootstrap.Modal.getOrCreateInstance("#shareRecipeModal");
        if (modal._isShown) {
          modal.hide();
        } else {
          setTimeout(() => {
            modal.hide();
          }, 1000);
        }
      }), { once: true });
    } else {
      alert(`You must select ${backskin} user${backskin > 1 ? "s" : ""} from the available list.`);
      $("#confirm-user-" + 0).prop("checked", false);
    }
  }

  selectUser(e) {
    let data = e.target.dataset;
    let index = data.index;
    let backskin = data.backskin;
    if (e.target.checked) {
      if (Number.parseInt(backskin) < $("#available-user-" + index + " input[type='checkbox'][name^='purchase_backskin[" + index + "]']:checked").length) {
        alert(`You can only select ${backskin} user${backskin > 1 ? "s" : ""} from the available list.`);
        $(e.target).prop("checked", false);
      }
    }
    $("#confirm-user-" + 0).prop("checked", false);

  }
}
